// src/pages/AboutMePage.js
import React from 'react';
import AboutMe from '../components/Aboutme';

const AboutMePage = () => {
  return (
    <div>
      <AboutMe />
    </div>
  );
};

export default AboutMePage;
